
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.208","height":"15.208"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-on-boarding"}},[_c('rect',{attrs:{"id":"Rectangle_7574","data-name":"Rectangle 7574","width":"15.208","height":"15.208","rx":"4","fill":"#fe5252","stroke":"#e4e8f2","stroke-width":"1"}})])]),_c('g',{attrs:{"id":"Group_21932","data-name":"Group 21932","transform":"translate(-770.572 -237.115)"}},[_c('g',{attrs:{"id":"Group_21927","data-name":"Group 21927","transform":"translate(770.572 237.115)"}},[_c('g',{attrs:{"id":"Mask_Group_21590","data-name":"Mask Group 21590"}},[_c('path',{attrs:{"id":"Path_19933","data-name":"Path 19933","d":"M-4.788-4.53l24.783 24.783","fill":"none","stroke":"#fe5252","stroke-width":"1.2"}})]),_c('g',{attrs:{"id":"Rectangle_7577","data-name":"Rectangle 7577","fill":"none","stroke":"#515a70","stroke-width":"1"}},[_c('rect',{attrs:{"width":"15.208","height":"15.208","rx":"4","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"14.208","height":"14.208","rx":"3.5"}})])])])])
          )
        }
      }
    